// NOTE: see inasaku-amplify#205
import isMobile from "ismobilejs";
export default {
  methods: {
    isMobileAny() {
      // return isMobile(window.navigator).any;
      return false;
    },
    isMobilePayment() {
      return isMobile(window.navigator).any && this.$route.path.includes("mobile");
    },
    isMobilePaymentNew() {
      return this.isMobilePayment() && !this.isMobilePaymentEdit();
    },
    isMobilePaymentEdit() {
      return this.isMobilePayment() && this.$route.path.includes("-edit");
    }
  }
};
